import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BrochureData } from './brochure.model';
import { BrochureService } from './brochure.service';

export class BrochureDataSource implements DataSource<BrochureData> {

  private dataSubject = new BehaviorSubject<BrochureData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private brochureService: BrochureService) {}

  connect(collectionViewer: CollectionViewer): Observable<BrochureData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadBrochures(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'created',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {
    this.loadingSubject.next(true);

    this.brochureService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.brochures);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
